import Spacings from '@dynatrace/strato-design-tokens/spacings';

/**
 * Defines the available gapSizes and their mapping to the tokens.
 * @public
 */
export const spacingProperties = {
  0: Spacings.Size0,
  2: Spacings.Size2,
  4: Spacings.Size4,
  6: Spacings.Size6,
  8: Spacings.Size8,
  12: Spacings.Size12,
  16: Spacings.Size16,
  20: Spacings.Size20,
  24: Spacings.Size24,
  32: Spacings.Size32,
  40: Spacings.Size40,
  48: Spacings.Size48,
  56: Spacings.Size56,
  64: Spacings.Size64,
};

/**
 * Union type of the available GapSizes
 * @public
 */
export type SpacingProperties = keyof typeof spacingProperties;

/** @public */
export const marginProperties = {
  ...spacingProperties,
  auto: 'auto',
};

/** @public */
export type MarginProperties = keyof typeof marginProperties;

const selfPosition = {
  center: 'center',
  end: 'end',
  'flex-end': 'flex-end',
  'flex-start': 'flex-start',
  'self-end': 'self-end',
  'self-start': 'self-start',
  start: 'start',
};

const contentDistribution = {
  'space-around': 'space-around',
  'space-between': 'space-between',
  'space-evenly': 'space-evenly',
  stretch: 'stretch',
};

const contentPosition = {
  center: 'center',
  end: 'end',
  'flex-end': 'flex-end',
  'flex-start': 'flex-start',
  start: 'start',
};

/** @public */
export const justifySelfPositionProps = {
  ...selfPosition,
  auto: 'auto',
  baseline: 'baseline',
  left: 'left',
  normal: 'normal',
  right: 'right',
  stretch: 'stretch',
};
/** @public */
export type JustifySelfPositionProps = keyof typeof justifySelfPositionProps;
/** @public */

export const alignSelfPositionProps = {
  ...selfPosition,
  auto: 'auto',
  baseline: 'baseline',
  normal: 'normal',
  stretch: 'stretch',
};
/** @public */
export type AlignSelfPositionProps = keyof typeof alignSelfPositionProps;

/** @public */
export const placeSelfPositionProps = {
  ...selfPosition,
  auto: 'auto',
  baseline: 'baseline',
  normal: 'normal',
  stretch: 'stretch',
};
/** @public */
export type PlaceSelfPositionProps = keyof typeof placeSelfPositionProps;

/** @public */
export const justifyItemsPositionProps = {
  ...selfPosition,
  baseline: 'baseline',
  left: 'left',
  legacy: 'legacy',
  normal: 'normal',
  right: 'right',
  stretch: 'stretch',
};
/** @public */
export type JustifyItemsPositionProps = keyof typeof justifyItemsPositionProps;

/** @public */
export const alignItemsPositionProps = {
  ...selfPosition,
  baseline: 'baseline',
  normal: 'normal',
  stretch: 'stretch',
};
/** @public */
export type AlignItemsPositionProps = keyof typeof alignItemsPositionProps;

/** @public */
export const placeItemsPositionProps = {
  ...selfPosition,
  baseline: 'baseline',
  normal: 'normal',
  stretch: 'stretch',
};
/** @public */
export type PlaceItemsPositionProps = keyof typeof placeItemsPositionProps;

/** @public */
export const justifyContentPositionProps = {
  ...contentDistribution,
  ...contentPosition,
  left: 'left',
  normal: 'normal',
  right: 'right',
};
/** @public */
export type JustifyContentPositionProps =
  keyof typeof justifyContentPositionProps;

/** @public */
export const alignContentPositionProps = {
  ...contentDistribution,
  ...contentPosition,
  baseline: 'baseline',
  normal: 'normal',
};
/** @public */
export type AlignContentPositionProps = keyof typeof alignContentPositionProps;

/** @public */
export const placeContentPositionProps = {
  ...contentDistribution,
  ...contentPosition,
  baseline: 'baseline',
  normal: 'normal',
};
/** @public */
export type PlaceContentPositionProps = keyof typeof placeContentPositionProps;
